import { render, staticRenderFns } from "./ImageInfoOverlay.vue?vue&type=template&id=72310c5c"
import script from "./ImageInfoOverlay.vue?vue&type=script&lang=js"
export * from "./ImageInfoOverlay.vue?vue&type=script&lang=js"
import style0 from "./ImageInfoOverlay.vue?vue&type=style&index=0&id=72310c5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports